import { WIZ_EVENT_TYPE, VALUE_ENTER, VALUE_ESCAPE, WizDateUtils } from '@wizeoo/akm-core-lib';
import {
  FilterComponent,
  WizBasePopUp,
  WizDatasource,
  WizAgGrid,
  WizAgGridUtils,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { FeiVO } from '../../../../../vo/workingdata/fei.vo';
import { FreedataValueVO } from  '../../../../../vo/core/freedatavalue.vo';
import { IWidget, IWidgetFilter } from '../../../../../manager/widgets/i-widget';
import { PivotCellEditPopData } from '../../../../../manager/widgets/i-widget';
import { BaselineEngine, EM_ACTION, FIELD_KIND, FeiKeyDef, WidgetLine, WizConstants } from '@wizeoo/akm-compute-lib';
import { WidgetConfigurationItemObj } from '@wizeoo/akm-message-lib';
import { ColDef } from 'ag-grid-community';
import { WizColDef } from '../../../../../manager/workingdata/fei.engine';
import { UpdateRequest } from '../../../../../command/core/sync/sync.service';
import { ViewData } from '../../../../../model/view.data';
import { FreedataArgsVO } from  '../../../../../vo/core/freedataargs.vo';
import { Model } from '../../../../../model/model';


@Component({
  // popUp d'édition des cellules de type filterKey
  selector: 'pivot-cell-filterkey-edit-pop',
  templateUrl: './pivot-cell-filterkey-edit.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PivotCellFilterkeyEditPop extends WizBasePopUp {

  @ViewChild('popFilter', { read: FilterComponent }) popFilter: FilterComponent; // filtre des mesures
  @ViewChild('agGrid') agGrid: WizAgGrid<FreedataValueVO>;


  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === VALUE_ENTER) {
      this.save();
    }
    if (event.key === VALUE_ESCAPE) {
      this.doCancel();
    }
  }

  /** accesseur avec cast */
  public get popupData(): PivotCellEditPopData {
    return this.datas as PivotCellEditPopData;
  }

  public columns: ColDef[]; // Colonnes du grid
  

  /** la DS ee la liste. On recycle le mécanisme d'alimentation des filtres, il marche bien avec freedata et chrono */
  public mainDS: WizDatasource<FreedataValueVO> = new WizDatasource<FreedataValueVO>([])
    .setFilter(this.fdvFilterFunc.bind(this))
    .setSelectionMode('single')
    .setSortFields([{ property: 'trsLabel', way: 'asc', numeric: false }])
    .build();

 
  public static baseWidth: number = 450;
  public static baseHeight: number = 300;

  public fei: FeiVO = null; // l'instance de FEI manipulée par ce composant
  public widget: IWidget; // accesseur sur le widget
  public line: WidgetLine; // la pl de référence pour update
  public pack: WidgetLine[]; // le pool de line effectif. Prise en compte de l'aggrégat en colonne
  private fkd: FeiKeyDef;

  // objet sur FDV
  public fdv: FreedataValueVO;
  public arg: FreedataArgsVO;

  // protected doSaveFlag: boolean = true;   // marqueur de validation des modifs (false sur cancel)
  // protected saveMode: 'single'|'split' = 'single'; // mode de ventilation sur saisie en masse

  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super();
  }

  // on est sur un objet de FDV
  public freedataMode: boolean = false;

  // on est sur une mesure de type FILTER, pas sur une filterKey
  public isFilterMeasure: boolean = false;

  show(): void {
    this.widget = this.popupData.widget;
    this.fei = this.widget.fei as FeiVO;
    this.line = this.popupData.line;
    this.pack = this.popupData.pack;
    this.fkd = this.popupData.fkd;

    if(!!this.popupData.arg) { // mode freedata
      this.fdv = this.popupData.fdv;
      this.arg = this.popupData.arg;
      this.freedataMode = true;
    }

    // si c'est une mesure de type FILTER, override du FKD
    else if(this.fkd.isMeasure) {
      this.isFilterMeasure = true;
      // console.log('filter pop', this.popupData);
    }
    

    this.feedDatasources();
    this.addListeners();
  }

  /** sur séquence de démarrage, alimentation des listes avec leurs DS */
  public feedDatasources(): void {
    // console.log('cellParams', this.params);
    // this.lbTitle.wizLabel = this.datas.title;
    // lien avec le FDV. l'engine se charge de supprimer l'éventuel #level
    let FDCode: string;
    if(this.freedataMode) {
      FDCode = this.arg.datas;
    } else if(this.isFilterMeasure) {
      FDCode = (this.fkd.measure.settings as any).keys[0].FD;
    } else {
      FDCode = this.fkd.fullCode;
    }

    let fdvs: FreedataValueVO[] = [...this.widget.model.freedataEngine.getFreedataValuesByLevel(FDCode)]; 

    this.columns = this.buildColumns(); // générer les colonnes depuis le contexte
    
    this.popFilter.configure(['code', 'trsLabel'], null, null);
    
    if(this.isFilterMeasure) {
      let unique: boolean = !!(this.fkd.measure.settings as any).keys[0].unique;
      if(unique) {
        let existSet: Set<string> = new Set();
        [...this.fei.getAllLines()].forEach(wl => {
          let wlVal: string = BaselineEngine.getValue(this.fei, wl, wl?.cells?.get(this.fkd.fullCode)); 
          existSet.add(wlVal);
        });

        // console.log("unique existSet", existSet);

        let realsource: FreedataValueVO[]= [];
        fdvs.forEach(fdv => {
          if(existSet.has(fdv.shortCode)) {
            // console.log('out', fdv.shortCode);
          } else {
            realsource.push(fdv);
          }
        });
        fdvs = realsource;
      }
    }
    
    
    // const edit: PivotFilterKeyItemObj[] = allowedFdvs.map((fd: FreedataValueVO) => new PivotFilterKeyItemObj(fd));
    this.mainDS.setSource(fdvs);

    let rawValue: string = this.popupData.value; // pour les baselines
    if(this.freedataMode && !!rawValue) { // pour le FDGrid, on reçoit potentiellement la valeur du label, pas bon
      rawValue = this.fdv.argsObjVO[this.arg.code].split(WizConstants.CONTEXT_SEPARATOR)[1];
      // console.log('rawValue',rawValue);
    }

    let selected: FreedataValueVO[] = [];
    this.mainDS.getWorkedSource().forEach(item => {
      if(item.code === rawValue) {
        selected = [item];
      } 
    })
    if(selected?.length > 0) {
      this.mainDS.select(selected);
      this.agGrid.api.ensureIndexVisible(this.mainDS.getItemIndex(selected[0]));
    }

  }

  /** mise en place des écouteurs */
  public addListeners(): void {
    WizEventManager.addListener(this, this.agGrid, WIZ_EVENT_TYPE.SELECTION_CHANGED, this.innerSelectionChange);
    WizEventManager.addListener(this, this.popFilter, WIZ_EVENT_TYPE.FILTER, this.doFilter); // ecouteur sur le filtre des mesures & function
  }

  // filterFunc de la collection de fdv
  protected fdvFilterFunc(item: FreedataValueVO): boolean {
    
    if(item.deprecated) { // masquer les deprecated
      return false;
    }

    if(!!item.endDate && WizDateUtils.numberToDate(item.endDate) < WizDateUtils.TODAY) { // masquer les deprecated
      return false;
    }
    
    // contrôle par filtre utilisateur
    if(!this.widget.model.widgetEngine.doUserFilterOnFDV(item)) {
      return false;
    } 

    let filter: IWidgetFilter; // les filtres qu'on va jouer
    let result: boolean = true;
    // gestion du filtre global
    if(!!this.widget.model.widgetEngine.globalFilter) { 
      let globalFilter: IWidget = this.widget.model.widgetEngine.checkGlobalFilter();
      if(globalFilter.filters) { // filtre actifs sur le global
        for (var i = 0, len = globalFilter.filters.size; i < len; i++) {
          filter = [...globalFilter.filters.values()][i];
          if (filter.active) {
            // tester la propriété sur le FD.arg
            try {
              let realFD: string = filter.fkd.code;
              let realValues: Set<string> = filter.values;
              // on regarde si ce n'est pas un sous-objet
              if(filter.wcio.fdvf) {
                
                let sourceArg: FreedataArgsVO = this.widget.model.freedataEngine.getArgFromFD(filter.fkd.code, filter.wcio.fdvf);
                // console.log('filter.wcio.fdvf', filter.wcio.fdvf, sourceArg?.dataType);
                if(sourceArg?.dataType === FIELD_KIND.OBJECT) {
                  realFD = filter.wcio.fdvf;
                  // realValues = new Set( filter.values;
                }
              }

              let arg: FreedataArgsVO = item.getParentFDVO()?.getArgsVOMap()?.get(realFD);
              if(arg) {
                let fdvVal: string = item.argsObjVO[arg.code]?.split(WizConstants.CONTEXT_SEPARATOR)[1] || null;
                if(!filter.values.has(fdvVal) ) {
                  result = false;
                  break;
                }
              }    
            } catch(e:any) {
              console.log('oups global filter on filterKey', item.freeDataCode, item.code, e);
            }
          }    
        }
      }
    }

    // fin du contrôle global, première chance de rater
    if(!result) { // le filtre global me laisse passer
      return false; // filtré par le filtre global
    }

    //  depuis pivot: recycler les filtres
    if(this.widget.filters) { 
      for (var i = 0, len = this.widget.filters.size; i < len; i++) {
        filter = [...this.widget.filters.values()][i];
        if (filter.active) {
          
          try {
            let realFD: string = filter.fkd.code;
            let realValues: Set<string> = filter.values;
            // on regarde si ce n'est pas un sous-objet
            if(filter.wcio.fdvf) {
              
              let sourceArg: FreedataArgsVO = this.widget.model.freedataEngine.getArgFromFD(filter.fkd.code, filter.wcio.fdvf);
              // console.log('filter.wcio.fdvf', filter.wcio.fdvf, sourceArg?.dataType);
              if(sourceArg?.dataType === FIELD_KIND.OBJECT) {
                realFD = filter.wcio.fdvf;
                // realValues = new Set( filter.values;
              }
            }

            let arg: FreedataArgsVO = item.getParentFDVO()?.getArgsVOMap()?.get(realFD);
            if(arg) {
              let fdvVal: string = item.argsObjVO[arg.code]?.split(WizConstants.CONTEXT_SEPARATOR)[1] || null;
              if(!filter.values.has(fdvVal) ) {
                result = false;
                break;
              }
            }    
          } catch(e:any) {
            console.log('oups widget filter on filterKey', item.freeDataCode, item.code, e);
          }         
          
        }
      }
    }

    // fin du contrôle widget,
    if(!result) {
      return false; // filtré par le filtre du widget
    }

 
    if(!this.widget.model.widgetEngine.doUserFDVFilterOnFDV(this.widget, this.line, item)) {
      return false;
    } 

    return this.popFilter.checkVisible(item);
  }

  /**
   * modification du filtre des fdv
   * @param e WizEvent
   */
  protected doFilter(e: WizEvent): void {
    this.mainDS.refresh();
  }

  /**
   * Synchronisation du selected
   * @param pEvent wizEvent contenant l'item sélectionné
   */
  private innerSelectionChange(pEvent: WizEvent): void {

  }

  /** Sauvegarde, même valeur */
  public save(): void {
    let value: string = '';
    if (this.mainDS.selectedItem) {
      // console.log('select', this.mainDS.selectedItem);
      if(this.freedataMode) {
        value =[this.mainDS.selectedItem.freeDataCode, this.mainDS.selectedItem.code].join(WizConstants.CONTEXT_SEPARATOR);
      } else {
        value = this.mainDS.selectedItem.code;
      }
    }

    const updates: UpdateRequest = {
      fei: this.fei, 
      line: this.line,
      lines: this.pack, 
      operation: EM_ACTION.UPDATE,
      fkd: this.fkd,
      value,
      doSplit: false
    };

    this.popupData.updates = updates;
    this.popupData.callback(this.popupData); // on appelle la callback avec le pack d'updates

    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    // this.doSaveFlag = false;
    this.hide();
  }

  public hide() {
    WizEventManager.removeListener(this, this.agGrid, WIZ_EVENT_TYPE.SELECTION_CHANGED);
    WizEventManager.removeListener(this, this.popFilter, WIZ_EVENT_TYPE.FILTER);
    super.hide();
  }

  /** construction des colonnes */
  private buildColumns(): WizColDef[] {
    const cols: WizColDef[] = [];
    let col: WizColDef;

    let wcio: WidgetConfigurationItemObj = this.popupData.column['colDef'].wcio;
    
    let requiredCols: any[] = null;
    let idx: number = 1;
    if (!!wcio.fdvSearch) {
      requiredCols = [];
     wcio.fdvSearch.split(ViewData.KEY_SEPARATOR).forEach(s => {
      requiredCols.push({code: s, order: idx, width: 100});
      idx++;
     });

    } else if(this.isFilterMeasure) { // construction des colonnes pour une mesure de type Filter
     requiredCols = [];
    (this.fkd.measure.settings as any).keys[0].fields.forEach(k => {
      requiredCols.push(k);
     });
    }

    if (requiredCols?.length > 0) {
      // const required: string[] = wcio.fdvSearch.split(ViewData.KEY_SEPARATOR);

      const sortKey: any[] = []; // trier par ordre de colonnes

      requiredCols.forEach( colObj => {
        let col: string = colObj.code;

        let FDCode: string;
        if(this.isFilterMeasure) {
          FDCode = (this.fkd.measure.settings as any).keys[0].FD.split(WizConstants.CONTEXT_SEPARATOR)[0];
        } else {
          FDCode = this.fkd.code;
        }

        const arg: FreedataArgsVO = this.widget.model.freedataEngine.getArgFromFD(FDCode, col);
        let realField: string = 'argsObjVO' +'.'+ col;
        // TODO rendu des colonnes pour les sous-FD (genre Labs)
        let size: number = !!arg.defaultSize ? arg.defaultSize : colObj.width;
        sortKey.push({property: realField, way: 'asc', numeric: this.widget.model.dataEngine.datakindIsNumeric(arg.dataType)});
        let coldef: any = { headerName: arg.trsLabel, width: size, sortable: true, resizable: true, field: realField };
        coldef.widget = this.widget;
        if (arg.dataType === FIELD_KIND.BINARY) {
          coldef.cellClass = 'grid-cell-centered';
          coldef.cellRenderer = this.widget.model.gridAccessors.attachmentCellRender;
          coldef.valueFormatter = this.voidFormatter;
          coldef.tooltipField = null;
        } else if (arg.dataType === FIELD_KIND.BOOLEAN) {
          coldef.cellClass = 'cbox-cell';
          coldef.cellClass += ' no-edit';
          coldef.valueFormatter = this.voidFormatter;
          coldef.cellRenderer = WizAgGridUtils.CELL_CHECKBOX_RENDERER;
        } else if (arg.dataType === FIELD_KIND.OBJECT) {
          // console.log('obj on FD pop')
          coldef.valueFormatter = this.objectFormatter;
          // coldef.valueFormatter = this.voidFormatter;
        }

        cols.push(coldef);
      });
    }

    if(cols.length <=0) {
      col = {};  
      col.headerName = '$.common.code.$';
      col.field = 'shortCode';
      col.sortable = true;
      col.resizable = false;
      col.width = 80;
      cols.push(col);

      // label
      col = {};  
      col.headerName = '$.common.label.$';
      col.field = 'trsLabel';
      col.sortable = true;
      col.resizable = false;
      col.flex = 1;
      cols.push(col);
    }

    // console.log('PivotCellFilterkeyEditPop buildColumns', cols);
    return cols;
  
  }

  private voidFormatter(val: any): any {
    return val.value;
  }

  // alimentation correct des champs des sous-objet (label)
  private objectFormatter(val: any): any {
    let result: string = '';
    if(val.value) {
      // check sur les #NA
      try {

        const parts:string[] = val.value?.split(ViewData.CONTEXT_SEPARATOR);
        result = Model.getInstance().freedataEngine.universalFormat(val.value, "label")?.toString();
      } catch(e: any) {

      }
      

    }
    // console.log('val',val.value, result);
    return result;
  }

  public askForUnselect(): void {
    this.mainDS.clearSelection();
    // console.log('askForUnselect');
  }

}
